/**
 * Ленивая панель пакетов карт (docs/ui/viewer/14-offline-packs.md): код
 * пакетов (OPFS, манифест, загрузчик) нужен не каждому посетителю — стартовый
 * бандл его не платит (check:bundle). Без importChunk намеренно: панель не
 * критична, а перезагрузка страницы ради боковой панели оффлайн без кеша была
 * бы хуже, чем её отсутствие — установленные вырезки подхватывает offline-style
 * и без панели.
 */
import type { Venue } from '@app/rvf'
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'

interface PanelProps {
  readonly venue: Venue
}

let cached: ComponentType<PanelProps> | null = null

export function PacksLazy({ venue }: PanelProps) {
  // Ленивый инициализатор обязателен (см. IsoLazy): иначе Preact вызвал бы
  // компонент как функцию-инициализатор состояния.
  const [View, setView] = useState<ComponentType<PanelProps> | null>(() => cached)

  useEffect(() => {
    if (View) return
    let alive = true
    void import('./packs-panel')
      .then((m) => {
        cached = m.PacksPanel
        if (alive) setView(() => m.PacksPanel)
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [View])

  if (!View) return null
  return <View venue={venue} />
}
